(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
/* ══════════════════════════════════════════
   Good & Pure — Predictive Search v2
   Runs on BOTH desktop + mobile instances
══════════════════════════════════════════ */
(function () {
  'use strict';

  /* Boot one search instance per visible input */
  function initSearch(inputId, clearId, dropId, resultsId, footerId, viewAllId) {
    const input   = document.getElementById(inputId);
    const clearBtn= document.getElementById(clearId);
    const drop    = document.getElementById(dropId);
    const results = document.getElementById(resultsId);
    const footer  = document.getElementById(footerId);
    const viewAll = document.getElementById(viewAllId);

    if (!input) return;

    let timer = null, ctrl = null, lastQ = '';

    const php    = c  => (c / 100).toLocaleString('en-PH', { style: 'currency', currency: 'PHP' });
    const esc    = s  => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const hilite = (t, q) => t.replace(new RegExp(`(${esc(q)})`, 'gi'), '<mark>$1</mark>');
    const show   = el => el.removeAttribute('hidden');
    const hide   = el => el.setAttribute('hidden', '');

    function posFixedDropdown() {
      if (!drop.classList.contains('gp-dropdown--mobile')) return;
      const rect = input.closest('.header__search-wrap').getBoundingClientRect();
      drop.style.top = (rect.bottom + window.scrollY + 8) + 'px';
      /* for position:fixed we just need viewport offset */
      drop.style.top = (rect.bottom + 8) + 'px';
    }

    function openDD()  { posFixedDropdown(); show(drop); input.setAttribute('aria-expanded','true'); }
    function closeDD() { hide(drop); input.setAttribute('aria-expanded','false'); }

    /* Clear */
    input.addEventListener('input', () => {
      input.value.trim() ? show(clearBtn) : hide(clearBtn);
    });
    clearBtn.addEventListener('click', () => {
      input.value = ''; hide(clearBtn); closeDD(); input.focus();
    });

    /* Fetch from Shopify Predictive Search API */
    async function fetchProducts(q) {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      try {
        const r = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`,
          { signal: ctrl.signal }
        );
        if (!r.ok) throw new Error();
        const d = await r.json();
        return d?.resources?.results?.products ?? [];
      } catch(e) {
        if (e.name !== 'AbortError') console.warn('[GP Search]', e);
        return null;
      }
    }

    /* Render results */
    function render(products, q) {
      results.innerHTML = ''; hide(footer);
      if (!products) return;
      if (!products.length) {
        results.innerHTML = `<div class="gp-empty">No results for <strong>"${q}"</strong></div>`;
        return;
      }
      products.forEach(p => {
        const a   = document.createElement('a');
        a.className = 'gp-result'; a.href = p.url; a.setAttribute('role','option');
        const src = p.featured_image?.url
          ? p.featured_image.url.replace(/(\.[a-z]+)$/, '_80x80_crop_center$1')
          : null;
        const img = src
          ? `<img class="gp-thumb" src="${src}" alt="${p.title}" loading="lazy" width="46" height="46">`
          : `<div class="gp-thumb-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="3"/><path d="M3 9l4-4 4 4 4-4 4 4"/></svg></div>`;
        a.innerHTML = `${img}<div class="gp-info"><span class="gp-title">${hilite(p.title, q)}</span>${p.price_min ? `<span class="gp-price">${php(p.price_min)}</span>` : ''}</div>`;
        results.appendChild(a);
      });
      viewAll.href = `/search?type=product&q=${encodeURIComponent(q)}`;
      show(footer);
    }

    /* Debounced input */
    input.addEventListener('input', () => {
      const q = input.value.trim(); lastQ = q;
      clearTimeout(timer);
      if (q.length < 2) { closeDD(); return; }
      results.innerHTML = `<div class="gp-loading"><div class="gp-spinner"></div>Searching…</div>`;
      hide(footer); openDD();
      timer = setTimeout(async () => {
        const p = await fetchProducts(q);
        if (q === lastQ) render(p, q);
      }, 260);
    });

    /* Keyboard nav */
    input.addEventListener('keydown', e => {
      const items = [...results.querySelectorAll('.gp-result')];
      const cur   = results.querySelector('[aria-selected="true"]');
      let idx     = cur ? items.indexOf(cur) : -1;
      if (e.key === 'ArrowDown') {
        e.preventDefault(); cur?.removeAttribute('aria-selected');
        items[(idx + 1) % items.length]?.setAttribute('aria-selected','true');
      } else if (e.key === 'ArrowUp') {
        e.preventDefault(); cur?.removeAttribute('aria-selected');
        items[(idx - 1 + items.length) % items.length]?.setAttribute('aria-selected','true');
      } else if (e.key === 'Enter' && cur) {
        e.preventDefault(); window.location.href = cur.href;
      } else if (e.key === 'Escape') { closeDD(); input.blur(); }
    });

    /* Outside click */
    document.addEventListener('click', e => {
      if (!e.target.closest('#' + input.closest('.header__search-wrap').id)) closeDD();
    });

    /* Re-open on focus */
    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2 && results.children.length) openDD();
    });

    /* Reposition mobile dropdown on scroll/resize */
    window.addEventListener('resize',  () => { if (!drop.hidden) posFixedDropdown(); }, { passive: true });
    window.addEventListener('scroll',  () => { if (!drop.hidden) posFixedDropdown(); }, { passive: true });
  }

  /* Desktop instance */
  initSearch(
    'headerSearchInput',
    'gpClearBtn',
    'gpDropdown',
    'gpResults',
    'gpFooter',
    'gpViewAll'
  );

  /* Mobile instance */
  initSearch(
    'headerSearchInputMobile',
    'gpClearBtnMobile',
    'gpDropdownMobile',
    'gpResultsMobile',
    'gpFooterMobile',
    'gpViewAllMobile'
  );

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
